import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconFlashBolt = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13.4388 20.7948C12.4622 22.2054 10.25 21.5144 10.25 19.7987V15C10.25 14.8619 10.138 14.75 9.99997 14.75H5.90854C4.49688 14.75 3.66617 13.1645 4.4697 12.0039L10.5611 3.20513C11.5377 1.79453 13.75 2.4856 13.75 4.20124V8.99998C13.75 9.13805 13.8619 9.24998 14 9.24998H18.0914C19.5031 9.24998 20.3338 10.8354 19.5302 11.9961L13.4388 20.7948ZM11.75 19.7987C11.75 20.0438 12.066 20.1425 12.2055 19.941L18.2969 11.1423C18.4117 10.9765 18.2931 10.75 18.0914 10.75H14C13.0335 10.75 12.25 9.96648 12.25 8.99998V4.20124C12.25 3.95615 11.9339 3.85743 11.7944 4.05894L5.70299 12.8577C5.5882 13.0235 5.70687 13.25 5.90854 13.25H9.99997C10.9665 13.25 11.75 14.0335 11.75 15V19.7987Z",
		fill: "currentColor"
	})
});
export { SvgIconFlashBolt as ReactComponent };
